/* ---------------------------------------------------------------------------------------
 * about:设备名字文件，能否改变是根据 http://orvibo521.xicp.net:8190/display/mp/V1.3.0 中的需求来定
 * author:马兆铿
 * date:2018-8-16
 * ---------------------------------------------------------------------------------------- */

/* ----------------------------------------- 总体 ----------------------------------------- */

// 阿里别名列表，对应设备号，可以选择 type 那一类下的别名
const aliNameList = [
  {type: "outlet", list: [2, 10, 29, 43]},
  {type: "light", list: [0, 1, 19, 38, 102]},
  {type: "curtain", list: [8, 9, 34, 70, 73, 74, 75, 76, 106, 126, 127]},
  {type: "hanger", list: [52]},
  {type: "fan", list: [58]}
]

/*  判断设备是否能够改名，与plugName相对应
 * @param {num}deviceType
 * @return 找到时返回类型字符串，找不到则返回false
 * */
export const isCanChangeNameDevice = deviceType => {
  let type = false
  aliNameList.forEach(device => {
    device.list.forEach(item => {
      if (item === deviceType) {
        type = device.type
      }
    })
  })
  return type
}

/* ----------------------------------------- 特殊设备业务 ----------------------------------------- */
/* ------------------ 插座 ------------------ */
//允许的别名，key是后台保存的值，value是天猫精灵识别的值
export const plugList = [
  {value: "热水器", key: "waterheater"},
  {value: "电热水壶", key: "kettle"},
  {value: "灯", key: "light"},
  {value: "风扇", key: "fan"},
  {value: "电饭煲", key: "cooker"},
  {value: "加湿器", key: "humidifier"},
  {value: "饮水机", key: "waterdispenser"},
  {value: "插座", key: "outlet"}
]

/*  根据阿里类型查找对应的设备名字
 * @param {str}aligenieType阿里设备类型
 * */
export const getPlugName = aligenieType => {
  const ele = plugList.filter(item => {
    return item.key === aligenieType
  })
  if (ele && ele.length > 0) {
    return ele[0]
  }
  return {
    value: "",
    key: ""
  }
}

/**
 * 检查是否支持插座类的别名
 * @param deviceType
 */
export const checkIfSupportPlugName = deviceType => {
  // 不在这个列表的插座，都可以支持修改成插座名字
  const notSupportAliNameList = [
    8, // 是继电器，被设置成窗帘或者其它设备后，那就不需要「可以选择插座的名字」了
    9
  ]
  return !notSupportAliNameList.find(item => item === deviceType)
}



// WEBPACK FOOTER //
// ./src/utils/device/deviceName.js